<app-custom-toastr
	*ngIf="toastrState.show"
	[status]="toastrState.status"
	[message]="toastrState.message"
	[showClose]="true"
	(close)="hideToastr()"
></app-custom-toastr>
<app-shell class="qds-platform-desktop qds-main"></app-shell>
